module.exports = __webpack_public_path__ + "static/media/pause.2e43787e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Discography/icons/pause.svg
// module id = 73
// module chunks = 0